export const ReportingTemplateRoute = {
  REPORTINGTEMPLATES: 'reportingtemplates',
};

export const ReportingTemplatePathName = {
  REPORTINGTEMPLATES: 'reportingtemplates',
  REPORTINGTEMPLATESFORM_NEW: 'reportingtemplatesform:new',
  REPORTINGTEMPLATESFORM: 'reportingtemplatesform',
};

export const ReportingTemplateValues = {
  PREDEFINED_ID: '1',
};
